import { render, staticRenderFns } from "./IndexManager.vue?vue&type=template&id=40096f8b&scoped=true"
import script from "./IndexManager.vue?vue&type=script&lang=js"
export * from "./IndexManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40096f8b",
  null
  
)

export default component.exports